<template>
  <div class="modalView">
    <b-row>
      <b-col cols="6">
        <div class="search-winery">
          <b-form-input class="search-input" ref="newWine" :placeholder="$t('winelist.addWineModal.placeholderWinery')"
            v-model="searchWineryText" v-on:keyup.enter="loadWineries"></b-form-input>
        </div>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import DataService from '@/services/StrapiService'
import DataMappingService from '@/services/DataMappingService'
import { mapGetters } from 'vuex'


export default {
  name: 'SearchWinery',
  data() {
    return {
      searchWineryText: '',
			hasTypedEnoughSearchText: false,
			loading: false
    }
  },
	emits: ['foundWineries', 'hasTypedSearchText'],
  watch: {
		searchWineryText: function (val) {
			this.hasTypedEnoughSearchText = val.length > 2;
			this.$emit('hasTypedSearchText', this.hasTypedEnoughSearchText);
		}
	},
  methods: {

    /**
     * Search for Wineries with title and show only 
     * non-venue specific 'master-results' with venue => null and 
     * own venue specific results with venue => currentVenueId
     * 
     * Filter winery's wines also for 'master-results' with venue => null or currentVenueId
     */
    loadWineries() {
      this.searchFor(this.searchWineryText)
    },

    /**
     * Set the search text and trigger the winery search.
     * Used to pre-fill step 1 with the producer from a sheet row.
     *
     * @param {string} searchText The winery title to search for
     */
    searchFor(searchText) {
      if (searchText == null || searchText.trim() === '') {
        return
      }
      this.searchWineryText = searchText
      this.loading = true

      const venueId = this.getVenue.id

      DataService.searchWinery(searchText.trim()).then((response) => {
        const wineries = DataMappingService.mapSearchWineriesResponse(response, venueId)
        this.$emit('foundWineries', wineries);
        this.searchWineryText = ''
        this.loading = false
      }).catch((err) => {
        this.loading = false
        console.log(err)
      })
    },

  },
  computed: {
    ...mapGetters(['getVenue'])
  }
}
</script>

<style scoped></style>
